module.exports = __webpack_public_path__ + "components/bookings-payment/static/pin-checkmark-f94b6ae01f648d9e160a0da169de6cf5.svg";